export default __webpack_public_path__ + "static/19-ac0687536eecf183bb3fa299f96be7e6.jpg";